<template>
    <div ref="monitorIfScrolledImage"><p class="mb-0">{{ numberCounter }}<slot></slot></p></div>
</template>

<script>
import InViewportAnimationMixin from '~/mixins/InViewportAnimationMixin';
export default {
    mixins: [InViewportAnimationMixin],
    data() {
        return {
            numberCounter: 0
        }
    },
    props: {
        number: {
            type: Number,
            required: true,
            default: 0
        },
        speed: {
            type: Number,
            required: false,
            default: 50
        },
        step: {
            type: Number,
            required: false,
            default: 1
        }
    },
    methods: {
        isScrolledIntoViewAnimation() {
            this.numberTimer = setInterval(() => {
                if (this.numberCounter + this.step > this.number) {
                    this.numberCounter = this.number;
                    clearInterval(this.numberTimer);
                    return;
                }
                this.numberCounter += this.step;
                if (this.numberCounter === this.number) {
                    clearInterval(this.numberTimer);
                }
            }, this.speed)
        }
    }
}
</script>